import { ReportScheduleType } from '@type/report-schedule-type';

export class AppConstant {
    codeRegex = '^[a-zA-Z0-9\-\_\\.]*$';
    emailRegex: string = '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})(;[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,}))*;?$';
    usernameRegex: string = '^[a-zA-Z0-9-_\\.@]*$';
    passwordRegex: string = '^[a-zA-Z0-9!"#\$%&\'\(\)\*\+,-\./:;<=>\?@\[\\\]^_`{|}~]*$';
    passwordComplexityRegex: string = '(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)';
    phoneRegex = '^[0-9]*$';
    dollaregex = '^-?[0-9]*(\\.\\d*)?$';
    numRegex = '^-?([0-9]|([1-9][0-9]*))$';
    PositiveNumRegex = '^([0-9]|([1-9][0-9]*))$';
    positiveCurrencyRegex = '^([0-9]|([1-9][0-9]*))(\.[0-9][0-9]?)?$';
    positiveCurrencyRegexOneDecimalPlace = '^([0-9]|([1-9][0-9]*))(\.[0-9]?)?$';
    positiveCurrencyRegexTwoDecimalPlace = '^([0-9]|([1-9][0-9]*))(\.[0-9]{1,2})?$';
    positiveCurrencyRegexUnlimitedDecimalPlace = '^([0-9]|([1-9][0-9]*))([.][0-9]*)?$';
    shareholderRegexUnlimitedDecimalPlace = '^([0-9]|([1-9][0-9]*))([.][0-9]*)?$';
    zeroToOneHundredRegex = "^(?:100|[1-9]?[0-9])$";
    timeFormateRegex = "^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$";
    alphanumericRegex = '^[a-zA-Z0-9]*';
    nonNegativeIntegerRegex = "^\\d{0,}$";
    creditCardNoRegex = "^\\d{16,19}$";
    englishAndNumberOnlyRegex = '^[a-zA-Z0-9\+=\|/\?><.,:;\"\'\-~!@#$%^&\*\(\)\_|\\\\]+([a-zA-Z0-9\+=\|/\?><.,:;\"\'\-~!@#$%^&\*\(\)\_|\\\\ ])*$';
    zipCodeRegex = '^[0-9\-]*$';
    bankAccountNoRegex = '^[0-9\-]*$';
    urlRegex = '(https?|http)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]';
    capitalAlphanumericRegex = '^[A-Z0-9]*$';
    couponCodesRegex = '^[A-Z0-9,]*$';
    batchIdRegex = '^\\d+(,?\\d+)*$|^\\d+(-\\d+)?$';
    
    numPxRegex = '^([0-9]|([1-9][0-9]*))px$';
    numPercentRegex = '^([0-9]|([1-9][0-9]*))%$';

    dateFormat = 'yyyy-MM-dd';
    dayFormat = 'MM-dd';
    dateFormatForDatePicker = 'yyyy-mm-dd';
    dateFormatForBsDatePicker = 'YYYY-MM-DD';
    dateTimeFormat = 'yyyy-MM-dd HH:mm:ss';
    dateTimeFormatForReportFile = 'yyyyMMddHHmmss';
    timeFormat = 'HH:mm';
    timeFormatForTimePicker = 'HH:mm';

    pagination: {
        maxPageLinksInPager: number;
    } = {
            maxPageLinksInPager: 5
        }

    reportScheduleTypeDaily: ReportScheduleType = 'DAILY';
    reportScheduleTypeMonthly: ReportScheduleType = 'MONTHLY';
    reportScheduleTypeWeekly: ReportScheduleType = 'WEEKLY';

    swalCancelButtonColor = '#aaaaaa';
    swalConfirmButtonColor = '#3085d6';
    swalDeleteButtonColor = '#dd6b55';
    limitFileUpload = 10;
    maxCharacterCount: number = 15000;


    static HAS_BEEN_UPDATED = 'HAS_BEEN_UPDATED';
    static FAIL_TO_UPDATE = 'FAIL_TO_UPDATE';
    static HAS_BEEN_ADDED ='HAS_BEEN_ADDED';
    static FAIL_TO_ADD ='FAIL_TO_ADD';
    static HAS_BEEN_COPIED_SUCCESS = 'HAS_BEEN_COPIED_SUCCESS';
    static DUPLICATED_USER_EMAIL ='DUPLICATED_USER_EMAIL';
    static DUPLICATED_USER_LOGINNAME ='DUPLICATED_USER_LOGINNAME';
    static DUPLICATED_USER_LOGINNAME_AND_EMAIL ='DUPLICATED_USER_LOGINNAME_AND_EMAIL';
    static DELETE_ONEPAGE_TEMPLATE_FAIL ='DELETE_ONEPAGE_TEMPLATE_FAIL';
    static DELETE_ONEPAGE_TEMPLATE_SUCCESS ='DELETE_ONEPAGE_TEMPLATE_SUCCESS';



    //split flag;
    static USER_TASK_ASSIGN_NAME = ','
    static POST_USER_NAME = ','

}


